import FormHelperText from '@mui/material/FormHelperText'
import { styled } from '@mui/material/styles'

const HelpText = styled(FormHelperText)(() => ({}))
export default HelpText
